import React, { useContext, useEffect, useState } from "react";
import { ReactComponent as BackArrow } from "../../../images/BackArrowWithRadius.svg";
import { ReactComponent as Lut } from "../../../images/LutLogo.svg";
import { ReactComponent as TSYS } from "../../../images/TsysLogo.svg";
import { ReactComponent as FirstData } from "../../../images/FirstDataLogo.svg";
import "./AdminPricingSettings.scss";
import Service from "../../../services";
import { BankUserContext } from "../../../bankUserContext";
import { IOrgPricingModel } from "../../../models/AdminSettingsM/AdminSettingsModel";
import { catchError } from "../../../utils/Utils";
import PricingStructureIcon from "../../../commonfields/PricingStructureIcon";

interface PricingProps {
  pricingStructureHandler: Function;
  backButton: Function;
}

const PricingStructure = (props: PricingProps) => {
  const { pricingStructureHandler, backButton } = props;
  const [selectPricingStructure, setSelectPricingStructure] = useState<
    IOrgPricingModel[]
  >([]);

  const service = new Service();
  const context = useContext(BankUserContext);

  const getPricingStructure = () => {
    const payload = {
      screen: "PricingSettings",
      sections: "getPMTemplatesByOrgProdId",
      orgId: context.bankuserDetails?.organization?.orgId,
      isJsonReturnObject: false,
    };
    service
      .getOrgProductsByPricingOption(payload)
      .then((res) => {
        console.log(res?.data);
        setSelectPricingStructure(res?.data);
      })
      .catch((err) => catchError(err, true));
  };
  useEffect(() => {
    getPricingStructure();
  }, []);

  const data = [
    {
      id: 0,
      name: "Lut Pricing Structure",
      image: <Lut />,
    },
    {
      id: 1,
      name: "TSYS Pricing Structure",
      image: <TSYS />,
    },
    {
      id: 2,
      name: "First Data Pricing Structure",
      image: <FirstData />,
    },
  ];

  const selectedPricing = (m: any) => {
    pricingStructureHandler(m);
  };
  return (
    <div className="pricingStructure">
      <div className="headerContainer">
        <div className="backContainer" onClick={() => backButton()}>
          <BackArrow />
          <span className="backText">Back</span>
        </div>
        <div>Select a Pricing Structure for Payments:</div>
        <div></div>
      </div>
      <div className="structureList">
        {selectPricingStructure.map((m) => (
          <div className="structureItem" onClick={() => selectedPricing(m)}>
        <PricingStructureIcon productName = {m.pricingTemplateName}/>
            <div>{m.pricingTemplateName}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingStructure;
